<template>
  <b-modal
    no-close-on-backdrop
    id="new_user_profile"
    title="ADICIONAR PERFIL DE USUÁRIO"
    hide-footer
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
  >
    <form @submit.prevent="evOnSubmit">
      <div class="row">
        <div class="col-md-12">
          <label-required-field label="Nome" />
          <b-input type="text" ref="autofocus" v-model="name" />
          <warning-required-fields />
          <errors-messages :errors="errors" />
        </div>
        <div class="col-md-12 text-right">
          <v-btn :disabled="loading" type="submit" class="btn-save">
            <i class="fas fa-save mr-2 text-twenty"></i>
            {{ loading ? "Carregando" : "SALVAR" }}
          </v-btn>
        </div>
      </div>
    </form>
  </b-modal>
</template>

<script>
import toast from "../../lib/ToastNotification";
import api from "../../services/api";
import ErrorsMessages from "../Components/ErrorsMessages.vue";
import LabelRequiredField from "../Components/LabelRequiredField.vue";
import WarningRequiredFields from "../Components/WarningRequiredFields.vue";

export default {
  name: "NewUserProfile",

  components: { LabelRequiredField, WarningRequiredFields, ErrorsMessages },

  data() {
    return {
      errors: [],
      loading: false,

      name: "",
    };
  },

  methods: {
    async evOnShow() {
      this.errors = [];
      this.loading = false;
      this.name = "";
    },

    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnHide() {},

    async evOnSubmit() {
      try {
        this.loading = true;

        let { name } = this;

        if (String(name).toUpperCase() == "MASTER") {
          this.errors = ["Informe outro nome"];
          this.loading = false;
          return;
        }

        const data = { name };
        const response = await api.post("/rest-home/profile", data);
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$bvModal.hide("new_user_profile");
          this.$emit("created");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>